import { TestListMobile } from './TestListMobile';
export default TestListMobile;